import { useDidMount } from '@surveycake/rhooks';
import { facebookAppVersion, surveyLoginFacebookAppId } from 'config/system';
//	@ts-ignore
import load from 'load-script';
import { useState } from 'react';

export function useFaceboockSdk() {
  const [isInitialed, setIsInitialed] = useState(false);

  useDidMount(() => {
    load('//connect.facebook.net/zh_TW/sdk.js?SurveyCake', (error: any) => {
      if (!error) {
        FB.init({
          appId: surveyLoginFacebookAppId,
          cookie: true,
          xfbml: true,
          version: facebookAppVersion
        });
        setIsInitialed(true);
      }
    });
  });

  return isInitialed;
}
